/**
 * Country codes list for phone number fields
 * Format: { code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸' }
 */
export const COUNTRY_CODES = [{
  code: 'US',
  name: 'United States',
  dialCode: '+1',
  flag: '🇺🇸'
}, {
  code: 'GB',
  name: 'United Kingdom',
  dialCode: '+44',
  flag: '🇬🇧'
}, {
  code: 'CA',
  name: 'Canada',
  dialCode: '+1',
  flag: '🇨🇦'
}, {
  code: 'AU',
  name: 'Australia',
  dialCode: '+61',
  flag: '🇦🇺'
}, {
  code: 'DE',
  name: 'Germany',
  dialCode: '+49',
  flag: '🇩🇪'
}, {
  code: 'FR',
  name: 'France',
  dialCode: '+33',
  flag: '🇫🇷'
}, {
  code: 'IT',
  name: 'Italy',
  dialCode: '+39',
  flag: '🇮🇹'
}, {
  code: 'ES',
  name: 'Spain',
  dialCode: '+34',
  flag: '🇪🇸'
}, {
  code: 'NL',
  name: 'Netherlands',
  dialCode: '+31',
  flag: '🇳🇱'
}, {
  code: 'BE',
  name: 'Belgium',
  dialCode: '+32',
  flag: '🇧🇪'
}, {
  code: 'CH',
  name: 'Switzerland',
  dialCode: '+41',
  flag: '🇨🇭'
}, {
  code: 'AT',
  name: 'Austria',
  dialCode: '+43',
  flag: '🇦🇹'
}, {
  code: 'SE',
  name: 'Sweden',
  dialCode: '+46',
  flag: '🇸🇪'
}, {
  code: 'NO',
  name: 'Norway',
  dialCode: '+47',
  flag: '🇳🇴'
}, {
  code: 'DK',
  name: 'Denmark',
  dialCode: '+45',
  flag: '🇩🇰'
}, {
  code: 'FI',
  name: 'Finland',
  dialCode: '+358',
  flag: '🇫🇮'
}, {
  code: 'PL',
  name: 'Poland',
  dialCode: '+48',
  flag: '🇵🇱'
}, {
  code: 'IE',
  name: 'Ireland',
  dialCode: '+353',
  flag: '🇮🇪'
}, {
  code: 'PT',
  name: 'Portugal',
  dialCode: '+351',
  flag: '🇵🇹'
}, {
  code: 'GR',
  name: 'Greece',
  dialCode: '+30',
  flag: '🇬🇷'
}, {
  code: 'CZ',
  name: 'Czech Republic',
  dialCode: '+420',
  flag: '🇨🇿'
}, {
  code: 'HU',
  name: 'Hungary',
  dialCode: '+36',
  flag: '🇭🇺'
}, {
  code: 'RO',
  name: 'Romania',
  dialCode: '+40',
  flag: '🇷🇴'
}, {
  code: 'BG',
  name: 'Bulgaria',
  dialCode: '+359',
  flag: '🇧🇬'
}, {
  code: 'HR',
  name: 'Croatia',
  dialCode: '+385',
  flag: '🇭🇷'
}, {
  code: 'SK',
  name: 'Slovakia',
  dialCode: '+421',
  flag: '🇸🇰'
}, {
  code: 'SI',
  name: 'Slovenia',
  dialCode: '+386',
  flag: '🇸🇮'
}, {
  code: 'LT',
  name: 'Lithuania',
  dialCode: '+370',
  flag: '🇱🇹'
}, {
  code: 'LV',
  name: 'Latvia',
  dialCode: '+371',
  flag: '🇱🇻'
}, {
  code: 'EE',
  name: 'Estonia',
  dialCode: '+372',
  flag: '🇪🇪'
}, {
  code: 'JP',
  name: 'Japan',
  dialCode: '+81',
  flag: '🇯🇵'
}, {
  code: 'CN',
  name: 'China',
  dialCode: '+86',
  flag: '🇨🇳'
}, {
  code: 'KR',
  name: 'South Korea',
  dialCode: '+82',
  flag: '🇰🇷'
}, {
  code: 'IN',
  name: 'India',
  dialCode: '+91',
  flag: '🇮🇳'
}, {
  code: 'SG',
  name: 'Singapore',
  dialCode: '+65',
  flag: '🇸🇬'
}, {
  code: 'MY',
  name: 'Malaysia',
  dialCode: '+60',
  flag: '🇲🇾'
}, {
  code: 'TH',
  name: 'Thailand',
  dialCode: '+66',
  flag: '🇹🇭'
}, {
  code: 'PH',
  name: 'Philippines',
  dialCode: '+63',
  flag: '🇵🇭'
}, {
  code: 'ID',
  name: 'Indonesia',
  dialCode: '+62',
  flag: '🇮🇩'
}, {
  code: 'VN',
  name: 'Vietnam',
  dialCode: '+84',
  flag: '🇻🇳'
}, {
  code: 'NZ',
  name: 'New Zealand',
  dialCode: '+64',
  flag: '🇳🇿'
}, {
  code: 'ZA',
  name: 'South Africa',
  dialCode: '+27',
  flag: '🇿🇦'
}, {
  code: 'EG',
  name: 'Egypt',
  dialCode: '+20',
  flag: '🇪🇬'
}, {
  code: 'AE',
  name: 'United Arab Emirates',
  dialCode: '+971',
  flag: '🇦🇪'
}, {
  code: 'SA',
  name: 'Saudi Arabia',
  dialCode: '+966',
  flag: '🇸🇦'
}, {
  code: 'TR',
  name: 'Turkey',
  dialCode: '+90',
  flag: '🇹🇷'
}, {
  code: 'RU',
  name: 'Russia',
  dialCode: '+7',
  flag: '🇷🇺'
}, {
  code: 'BR',
  name: 'Brazil',
  dialCode: '+55',
  flag: '🇧🇷'
}, {
  code: 'MX',
  name: 'Mexico',
  dialCode: '+52',
  flag: '🇲🇽'
}, {
  code: 'AR',
  name: 'Argentina',
  dialCode: '+54',
  flag: '🇦🇷'
}, {
  code: 'CL',
  name: 'Chile',
  dialCode: '+56',
  flag: '🇨🇱'
}, {
  code: 'CO',
  name: 'Colombia',
  dialCode: '+57',
  flag: '🇨🇴'
}, {
  code: 'PE',
  name: 'Peru',
  dialCode: '+51',
  flag: '🇵🇪'
}, {
  code: 'VE',
  name: 'Venezuela',
  dialCode: '+58',
  flag: '🇻🇪'
}, {
  code: 'NG',
  name: 'Nigeria',
  dialCode: '+234',
  flag: '🇳🇬'
}, {
  code: 'KE',
  name: 'Kenya',
  dialCode: '+254',
  flag: '🇰🇪'
}, {
  code: 'GH',
  name: 'Ghana',
  dialCode: '+233',
  flag: '🇬🇭'
}, {
  code: 'PK',
  name: 'Pakistan',
  dialCode: '+92',
  flag: '🇵🇰'
}, {
  code: 'BD',
  name: 'Bangladesh',
  dialCode: '+880',
  flag: '🇧🇩'
}, {
  code: 'LK',
  name: 'Sri Lanka',
  dialCode: '+94',
  flag: '🇱🇰'
}, {
  code: 'NP',
  name: 'Nepal',
  dialCode: '+977',
  flag: '🇳🇵'
}, {
  code: 'MM',
  name: 'Myanmar',
  dialCode: '+95',
  flag: '🇲🇲'
}, {
  code: 'KH',
  name: 'Cambodia',
  dialCode: '+855',
  flag: '🇰🇭'
}, {
  code: 'LA',
  name: 'Laos',
  dialCode: '+856',
  flag: '🇱🇦'
}, {
  code: 'MN',
  name: 'Mongolia',
  dialCode: '+976',
  flag: '🇲🇳'
}, {
  code: 'TW',
  name: 'Taiwan',
  dialCode: '+886',
  flag: '🇹🇼'
}, {
  code: 'HK',
  name: 'Hong Kong',
  dialCode: '+852',
  flag: '🇭🇰'
}, {
  code: 'MO',
  name: 'Macau',
  dialCode: '+853',
  flag: '🇲🇴'
}];